import { memo, useEffect, useState } from 'react';
import { IconButton, Stack } from '@mui/material';
import ImageUploadContainer from 'components/Account/ImageUploadContainer';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { getBlobUrl } from 'utils/helpers';

export interface ChangePhotoProp {
    imgValue: string;
    setImgValue: Function;
    isLoading?: boolean;
    onRemoveClick?: Function;
}

function ChangePhoto({ imgValue, setImgValue, onRemoveClick }: ChangePhotoProp) {
    const [tab, setTab] = useState('uploadimage');
    const [clickedIndex, setClickedIndex] = useState(null);

    useEffect(() => {
        setTab('uploadimage');
    }, [imgValue]);

    const setTabValue = (value: string) => {
        setTab(value);
    };

    const handleRemoveClick = () => {
        if (onRemoveClick) {
            return onRemoveClick();
        }
        setImgValue('');
    };
    if (imgValue) {
        return (
            <Stack width="100%" alignItems="center" justifyContent="center" mb={10}>
                <IconButton sx={{ ml: 30 }}>
                    <RemoveCircleOutlineIcon onClick={handleRemoveClick} />
                </IconButton>
                <img src={getBlobUrl(imgValue)} alt="Image" style={{ width: '200px', height: '200px', objectFit: 'contain' }} />
            </Stack>
        );
    }

    return <ImageUploadContainer imgValue={imgValue} setImgValue={setImgValue} />;
}

export default memo(ChangePhoto);
